import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzIcon',
  props: {
    iconName: null,
    color: {
      default: 'var(--c-primary-800)'
    },
    size: {
      default: 'normal'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var iconSize = computed(function () {
      switch (props.size) {
        case 'smallest':
          return '14px';
          break;
        case 'smaller':
          return '16px';
          break;
        case 'small':
          return '20px';
          break;
        case 'normal':
          return '24px';
          break;
        case 'large':
          return '28px';
          break;
        case 'larger':
          return '30px';
          break;
        case 'largest':
          return '32px';
          break;
        default:
          return props.size;
      }
    });
    var iconStyle = computed(function () {
      return [{
        '--az-icon-color': props.color
      }, {
        '--az-icon-size': iconSize.value
      }];
    });
    return {
      __sfc: true,
      props: props,
      iconSize: iconSize,
      iconStyle: iconStyle
    };
  }
});